//一度限りの購入を通常購入に変更 
document.addEventListener("DOMContentLoaded", function() {
    const wrapperElements = document.querySelectorAll(".shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper");

    if (wrapperElements.length > 0) {
        wrapperElements.forEach(wrapper => {
            const label = wrapper.querySelector("label");

            if (label) {
                // label 内のテキストノードを取得（input はそのまま維持する）
                label.childNodes.forEach(node => {
                    if (node.nodeType === Node.TEXT_NODE) {
                        node.nodeValue = node.nodeValue.replace("一度限りの購入", "通常購入");
                    }
                });
            }
        });
    }

    // 1か月ごとの購入を定期購入に変更
    const listItems = document.querySelectorAll(".shopify_subscriptions_app_block_label_children li");

    listItems.forEach(li => {
        const label = li.querySelector("label");
        
        if (label) {
            // テキストノードを変更
            label.childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                    node.nodeValue = node.nodeValue.replace("毎月配達", "定期購入");
                }
            });
        }
    });

//カートの数値（小数点以下の非表示）カスタム
    const liElements = document.querySelectorAll(".shopify_subscriptions_app_block_label_children li");
    liElements.forEach(li => {
        const label = li.querySelector("label");

        if (label) {
            // label 内のテキストノードを取得（input はそのまま維持する）
            label.childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                    let text = node.nodeValue.trim();
                    let match = text.match(/￥([\d,]+(?:\.\d+)?)/);
                    if (match) {
                        let price = parseFloat(match[1].replace(/,/g, ''));

                        if (!isNaN(price)) {
                            let formattedPrice = Math.round(price).toLocaleString();
                            node.nodeValue = text.replace(match[0], `￥${formattedPrice}`);
                        }
                    }
                }
            });
        }
    });

    const policyElement = document.querySelector(".shopify_subscriptions_app_policy");
    if (policyElement) {
        policyElement.innerText = policyElement.innerText.replace(
            "いつでも自動更新、スキップ、キャンセルできます。",
            "いつでもスキップ、キャンセルできます。"
        );
    }
});
